function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

export default {
  created () {
    const title = getTitle(this)
    if (title) {
      let host
      const mode = process.env.VUE_APP_MODE
      mode === 'ats' || mode === 'atsDev' ? host = 'ATS' : (mode === 'adam' || mode === 'adamDev' ? host = 'Adam travel' : host = 'Fare33')
      document.title = host + title
    }
  }
}
